module.exports = (elem) => elem.classList.contains("is-ative");
